import Cookies from 'js-cookie'
const schoolCode = 'school-Code' //学校识别码
const TokenKey = 'Admin-Token' // 登录token
const UuidKey = 'Uu-id' // 用户id
const schoolIdKey = 'school-Id' //学校id
const IsAdmin = 'isAdmin' // 管理员状态


// 学校识别码
export function getschoolCode() {
    return Cookies.get(schoolCode)
}
export function setschoolCode(id) {
    return Cookies.set(schoolCode, id)
}
export function removeschoolCode() {
    return Cookies.remove(schoolCode)
}

// token
export function getToken() {
    // return sessionStorage.getItem("Admin-Token")
    return Cookies.get(TokenKey)
}
export function setToken(token) {
    // return sessionStorage.setItem("Admin-Token", token);
    return Cookies.set(TokenKey, token)
}
export function removeToken() {
    // return sessionStorage.removeItem("Admin-Token")
    return Cookies.remove(TokenKey)
}


// 用户UID
export function getUuidKey() {
    // return sessionStorage.getItem("Admin-Token")
    return Cookies.get(UuidKey)
}
export function setUuidKey(token) {
    // return sessionStorage.setItem("Admin-Token", token);
    return Cookies.set(UuidKey, token)
}
export function removeUuidKey() {
    // return sessionStorage.removeItem("Admin-Token")
    return Cookies.remove(UuidKey)
}


// 学校id
export function getschoolIdKey() {
    // return sessionStorage.getItem("Admin-Token")
    return Cookies.get(schoolIdKey)
}
export function setschoolIdKey(token) {
    // return sessionStorage.setItem("Admin-Token", token);
    return Cookies.set(schoolIdKey, token)
}
export function removeschoolIdKey() {
    // return sessionStorage.removeItem("Admin-Token")
    return Cookies.remove(schoolIdKey)
}


// 管理员状态
export function getIsAdmin() {
    // return sessionStorage.getItem("Admin-Token")
    return Cookies.get(IsAdmin)
}
export function setIsAdmin(token) {
    // return sessionStorage.setItem("Admin-Token", token);
    return Cookies.set(IsAdmin, token)
}
export function removeIsAdmin() {
    // return sessionStorage.removeItem("Admin-Token")
    return Cookies.remove(IsAdmin)
}






// 退出登录 清楚token
export function logOut(){
    removeschoolCode();
    removeToken();
    removeUuidKey();
    removeschoolIdKey();
    removeIsAdmin();
}